import { render, staticRenderFns } from "./JLCT6View.vue?vue&type=template&id=ffb5c778&"
import script from "./JLCT6View.vue?vue&type=script&lang=js&"
export * from "./JLCT6View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports